import React from 'react'
import { ReactComponent } from './route.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface Co2Props {
  color?: string
}

type Props = MergeReactElementProps<'svg', Co2Props>

export const RouteIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
